// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=Country|schemaHash=7e306db635c0d0c996ab9bc79fce78fd8f6e7f23

import { setDefinedValue } from '@myre/common-primitives';

import { parseTranslationFromJSON, parseTranslationToJSON } from './Translation';

export function parseCountryFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'name',
    parseTranslationFromJSON(
      _data.name
    ),
  );
  setDefinedValue(result, 'mainCountryId', _data.mainCountryId);
  setDefinedValue(result, 'alpha2', _data.alpha2);
  setDefinedValue(result, 'alpha3', _data.alpha3);
  setDefinedValue(result, 'numericCode', _data.numericCode);
  setDefinedValue(result, 'phoneIndicator', _data.phoneIndicator);
  setDefinedValue(result, 'id', _data.id);

  return result;
}

export function parseCountryToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(
    result,
    'name',
    parseTranslationToJSON(
      _data.name
    ),
  );
  setDefinedValue(result, 'mainCountryId', _data.mainCountryId);
  setDefinedValue(result, 'alpha2', _data.alpha2);
  setDefinedValue(result, 'alpha3', _data.alpha3);
  setDefinedValue(result, 'numericCode', _data.numericCode);
  setDefinedValue(result, 'phoneIndicator', _data.phoneIndicator);
  setDefinedValue(result, 'id', _data.id);

  return result;
}
